import { SectionTypes } from '@fiverr-private/ai_brief';

const sectionTypeMap: Record<string, SectionTypes> = {
    GENERATED: SectionTypes.generated,
    METADATA: SectionTypes.metadata,
    STANDARD: SectionTypes.shortText,
};

export const mapSectionType = (type: string): SectionTypes => sectionTypeMap[type] ?? SectionTypes.shortText;
